//Margin conventions
var margin = {top: 5, right: 15, bottom: 30, left: 60};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 300 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;  

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
  .ticks(8)
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(8)
	.orient("bottom")
  .ticks(3)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .x(function(d) { return xScale(d.date); })
  .y(function(d) { return yScale(d.count); }); 

//area function
//var area = d3.svg.area()
//  .x(function(d) {return xScale(d.date); }) 
//  .y0(height)  
//  .y1(function(d) {return yScale(d.count); });    

//Loads the data
d3.csv("data/latinorate.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.count = +d.count;
    d.date = parseDate(d.date);
	});
	
	//Organizes the data	
  data.sort(function(a,b) { return a.date - b.date; });
  var maxY = d3.max(data, function(d) { return d.count; });
  var maxX = d3.max(data, function(d) { return d.date; });

  //Nest the data
  var dataByCategory = d3.nest()
    .key(function(d) { return d.category;})
    .entries(data);

  //Mapped to xy
  var plots = dataByCategory.map(function(plots) {
    return data.map(function(d) {
      return {x: +d.date, y: +d.count, cat: d.category};
    });
  });  

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.date; }));

  //Defines the yScale max
  yScale.domain([350000, maxY + 50000]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);   

  //data join for paths 
  var drawline = svg.selectAll(".cat-path")
    .data(dataByCategory)
    .enter()
    .append("path")
    .attr("class", "cat-path")
    .attr("d", function(d) { return line(d.values) })
    .classed("republican-line", function(d) { return d.key == "republican"; })
    .classed("democratic-line", function(d) { return d.key == "democratic"; });

 //Add the dots
  var dots = svg.selectAll(".dots")
    .data(plots)
    .enter().append("g")
    .attr("class", "dots")
    .selectAll(".point")
    .data(function(d) { return d; })
    .enter().append("circle")
    .attr("class", "point")
    .attr("r", 3.5)
    .attr("cx", function(d) { return xScale(d.x); })
    .attr("cy", function(d) { return yScale(d.y); })
    .attr("class", function(d) {
      if (d.cat == "republican") {
        return "republican-dot";
      }
      else {
        return "democratic-dot";
      };
    });

  //Append labels  
  var demlabel = svg.append("text")
      .text("Democrat")
      .attr("class", "dem-label")
      .attr("x", width/1.5)
      .attr("y", height/4.25);    

  var replabel = svg.append("text")
      .text("Republican")
      .attr("class", "rep-label")
      .attr("x", width/5)
      .attr("y", height/1.3);      

//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 5, right: 15, bottom: 30, left: 60};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .x(function(d) { return xScale(d.date); })
      .y(function(d) { return yScale(d.count); }); 

    d3.selectAll('.cat-path')
      .attr("d", function(d) { return line(d.values) }) 
    
    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(3);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

    dots
      .attr("cx", function(d) { return xScale(d.x); })
      .attr("cy", function(d) { return yScale(d.y); });

    demlabel
      .attr("x", newWidth/1.5);

    replabel  
       .attr("x", newWidth/5);
      
  };

}